// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";
import Loading from "./components/lib/loading";
import CenterContainer from "./components/lib/center-container";

import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import axios from "axios";

import { AUTH_LOGOUT } from "./store/actions/auth";


Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

Vue.config.productionTip = false

Vue.component("loading", Loading);
Vue.component("center-container", CenterContainer);

Vue.prototype.$window = window;

if (axios.defaults.headers.common["Authorization"] === undefined) {
    var token = localStorage.getItem("id_token");
    if (token !== undefined) {
        axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    }
}

/* eslint-disable no-new */
new Vue({
    router,
    store,
    template: "<App/>",
    render: h => h(App)
}).$mount('#app');


// axios.interceptors.response.use(undefined, function (err) {
//     return new Promise(function () {
//         if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
//             // if you ever get an unauthorized, logout the user
//             this.$store.dispatch(AUTH_LOGOUT).then(() => this.$router.push("/login"));
//         }
//         throw err;
//     });
// });

axios.interceptors.response.use(
    response => {
        if (response.status === 200 || response.status === 201) {
            return Promise.resolve(response);
        } else {
            return Promise.reject(response);
        }
    },
    error => {
        if (error.response.status) {
            switch (error.response.status) {
                // case 400:

                //     //do something
                //     break;

                case 401:
                    store.dispatch(AUTH_LOGOUT).then(() => router.push("/login"));
                    break;
                // case 403:
                //     router.replace({
                //         path: "/login",
                //         query: { redirect: router.currentRoute.fullPath }
                //     });
                //     break;
                // case 404:
                //     alert('page not exist');
                //     break;
                // case 502:
                //     setTimeout(() => {
                //         router.replace({
                //             path: "/login",
                //             query: {
                //                 redirect: router.currentRoute.fullPath
                //             }
                //         });
                //     }, 1000);
            }
            return Promise.reject(error.response);
        }
    }
);